import { apiDelete, apiGet, apiPost, apiPut, API_URI } from 'api';
import {ReactionListRequestType, WordBinGroupType} from 'types';

const reactionLists = {
    getAll: async (clientId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/getall?clientId=` + clientId);
        return data;
    },
    get: async (reactionListId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/get?id=` + reactionListId);
        return data;
    },
    getWordBinGroups: async (clientId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/group/getall?clientId=` + clientId);
        return data;
    },
    getWordBinLogs: async(wordBinId:number)=>{
        const data = apiGet(`${API_URI}/api/wordbins/logs?id=` + wordBinId);
        return data;
    },
    getWordBinsFromGroups: async (groupId: number) => {
        const data = apiGet(`${API_URI}/api/wordbins/group/getfromgroup/` + groupId);
        return data;
    },
    getWordflow: async (wordBinId: number) => {
        const data = apiGet(`${API_URI}/api/workflow/get/wordbin/?wordBinId=` + wordBinId);
        return data;
    },
    getWordflowDetails: async (workflowId: number) => {
        const data = apiGet(`${API_URI}/api/workflow/group/getall?workflowId=` + workflowId);
        return data;
    },
    update: async (reactionList: ReactionListRequestType) => {
        const data = apiPut(`${API_URI}/api/wordbins/update`, reactionList);
        return data;
    },
    save: async (reactionList: ReactionListRequestType) => {
        const data = apiPost(`${API_URI}/api/wordbins/save`, reactionList);
        return data;
    },
    delete: async (reactionListId: number) => {
        const data = apiDelete(`${API_URI}/api/wordbins/delete?id=${reactionListId}`);
        return data;
    },
    addGroup: async (id:number, description:string)=>{
        const data = apiPost(`${API_URI}/api/wordbins/group/create/${id}/${description}`);
        return data;
    },
    deleteGroup: async (groupId: number) => {
        const data = apiDelete(`${API_URI}/api/wordbins/group/delete?id=${groupId}`);
        return data;
    },
    addToGroup: async (wordBinId:number, groupId:number)=>{
        const data = apiPost(`${API_URI}/api/wordbins/group/add/${wordBinId}/${groupId}`);
        return data;
    },
    CreateGroup: async (wordBinId:number, name:string)=>{
        const data = apiPost(`${API_URI}/api/workflow/create?wordBinId=`+wordBinId+`&name=`+name);
        return data;
    },
    deleteWorkflowGroup: async (workFlowId: number) => {
        const data = apiDelete(`${API_URI}/api/workflow/delete?workFlowId=${workFlowId}`);
        return data;
    },
    setAsDefault: async (workflowId:number , workflowGroupId:number) => {
        const data = apiPut(`${API_URI}/api/workflow/group/default?workflowId=`+workflowId+`&workflowGroupId=`+workflowGroupId);
        return data;
    },
    getWorkflowCips: async (workflowGroupId: number,startDate:string,endDate:string,projectId:number) => {
        const data = apiGet(`${API_URI}/api/workflow/clip/getall?workflowGroupId=` + workflowGroupId+`&startDate=`+startDate+`&endDate=`+endDate+`&projectId=`+projectId);
        return data;
    },
    updateClip: async (workflowGroupId: number, groupId:number) => {
        const data = apiPut(`${API_URI}/api/workflow/clip/update?workflowClipId=`+ workflowGroupId+`&groupId=`+groupId);
        return data;
    },


    
}

export default reactionLists;